var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { css, html, LitElement, nothing } from "lit";
import { ref, createRef } from 'lit/directives/ref.js';
import { customElement, property } from "lit/decorators.js";
const customEl = "range-input";
let RangeInput = class RangeInput extends LitElement {
    constructor() {
        super(...arguments);
        this.step = "5";
        this.max = "100";
        this.min = "0";
        this.value = "10";
        this.inputRef = createRef();
        this.lowerColor = "var(--irange-accent-color)";
        this.higherColor = "var(--irange-bg-color)";
    }
    firstUpdated() {
        this.inputRef.value.style.background = `linear-gradient(to right, ${this.lowerColor} 0%, ${this.lowerColor} ${(parseInt(this.value) - parseInt(this.min)) / (parseInt(this.max) - parseInt(this.min)) * 100}%, ${this.higherColor} ${(parseInt(this.value) - parseInt(this.min)) / (parseInt(this.max) - parseInt(this.min)) * 100}%, ${this.higherColor} 100%)`;
    }
    _inputNumber() {
        return html `<div class="number"><div class="number-wrapper"><input @input=${this._inputChanged} @change=${this._inputChanged} type="number" min=${this.min} max=${this.max} .value=${this.value} />${this.value === this.max ? html `<span>et +</span>` : nothing}</div></div>`;
    }
    _inputRange() {
        return html `<div class="range"><input @input=${this._inputChanged} ${ref(this.inputRef)} type="range" min=${this.min} max=${this.max} .value=${this.value} step=${parseInt(this.step)} /></div>`;
    }
    render() {
        return html `${this._inputNumber()}${this._inputRange()}`;
    }
    updated(changedProperties) {
        if (changedProperties.has('value') && this.value) {
            this.inputRef.value.style.background = `linear-gradient(to right, ${this.lowerColor} 0%, ${this.lowerColor} ${(parseInt(this.value) - parseInt(this.min)) / (parseInt(this.max) - parseInt(this.min)) * 100}%, ${this.higherColor} ${(parseInt(this.value) - parseInt(this.min)) / (parseInt(this.max) - parseInt(this.min)) * 100}%, ${this.higherColor} 100%)`;
        }
    }
    _inputChanged(event) {
        const target = event.target === this ? event.composedPath()[0] : event.target;
        if (!target)
            return;
        let value = target.value;
        if (parseInt(value) > parseInt(this.max)) {
            value = this.max;
            target.value = this.max;
        }
        ;
        if (parseInt(value) < parseInt(this.min)) {
            value = this.min;
            target.value = this.min;
        }
        ;
        this.changeValue(value);
    }
    changeValue(value) {
        this.value = value;
        this.dispatchEvent(new CustomEvent("valueChanged", {
            detail: { value },
            bubbles: true,
            composed: true,
        }));
    }
};
RangeInput.styles = css `
input[type="range"] {
  --irange-height: calc(1.75rem - clamp(0rem, 1.5vw, 1.35rem));
  --irange-thumb-height: calc(2.25rem - clamp(0rem, 1.5vw, 1rem));
  margin: 0;
  width: 100%;
  border: none;
  outline: none;
  padding: 1px 2px;
  appearance: none;
  border-radius: 1rem;
  height: var(--irange-height);
  box-shadow:
    inset 0 1px 0 0 var(--irange-shadow-color),
    inset 0 -1px 0 0 var(--irange-shadow-color);

  &::-webkit-slider-thumb {
    z-index: 2;
    anchor-name: --range-input-slider;
    border: none;
    appearance: none;
    position: relative;
    border-radius: 9999px;
    width: var(--irange-thumb-height);
    height: var(--irange-thumb-height);
    box-shadow: 0 0 1px 0 color-mix(in lch, var(--irange-thumb-color), transparent 50%);
    background-image: linear-gradient(
        to bottom,
        oklch(from var(--irange-thumb-color) calc(l + 0.05) c h) 0,
        oklch(from var(--irange-thumb-color) calc(l - 0.05) c h)
    );
  }

  &::-moz-range-track {
    border: inherit;
    background: transparent;
  }

  &::-moz-range-thumb {
    border: none;
    border-radius: 9999px;
    width: var(--irange-thumb-height);
    height: var(--irange-thumb-height);
    box-shadow: 0 0 1px 0 color-mix(in lch, var(--irange-thumb-color), transparent 50%);
    background-image: linear-gradient(
      to bottom,
      oklch(from var(--irange-thumb-color) calc(l + 0.05) c h) 0,
      oklch(from var(--irange-thumb-color) calc(l - 0.05) c h)
    );
}
}
div.range {
  position: relative;
  height: min-content;
  line-height: 0;
}
div.number-wrapper {
  gap: .5ch;
  display: flex;
  text-align: center;
  padding: .5rem 1rem;
  border-radius: .5rem;
  align-items: baseline;
  color: var(--irange-text-color);
  background-color: var(--irange-bg-color);

  & span {
    font-size: 82.5%;
    white-space: nowrap;
  }
}
input[type="number"] {
  border: none;
  background: none;
  field-sizing: content;
  -moz-appearance: textfield;
  color: var(--irange-text-color);

  &:focus {
    outline: none;
  }
  
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
div.number {
  transform: translateY(-.5rem);
  display: flex;
  justify-content: center;
}
@supports (anchor-name: --range-input-slider) {
  div.number {
    position-anchor: --range-input-slider;
    position-area: top center;
    position: absolute;
    display: block;

    &::before {
      content: "";
      position: absolute;
      border: .5rem solid transparent;
      border-top-color: white;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
`;
__decorate([
    property(),
    __metadata("design:type", Object)
], RangeInput.prototype, "step", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], RangeInput.prototype, "max", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], RangeInput.prototype, "min", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], RangeInput.prototype, "value", void 0);
RangeInput = __decorate([
    customElement(customEl)
], RangeInput);
export { RangeInput };
